@if (options.head || options.type === "SERVER_SIDE") {
  <div class="table-header-container">
    @if (options.head) {
      <div class="table-head">
        <div class="view-selector">
          <button [class.selected]="view === 'list'" (click)="setView('list')" tooltip="TOOLTIP.TABLE.LIST_VIEW">
            <mat-icon>view_list</mat-icon>
          </button>
          @if (options.tile) {
            <button [class.selected]="view === 'tile'" (click)="setView('tile')" tooltip="TOOLTIP.TABLE.TILE_VIEW">
              <mat-icon>grid_view</mat-icon>
            </button>
          }
          @if (options.map) {
            <button [class.selected]="view === 'map'" (click)="setView('map')" tooltip="TOOLTIP.TABLE.MAP_VIEW">
              <mat-icon>map</mat-icon>
            </button>
          }
        </div>
        <div class="search-terms">
          <form>
            @for (key of searchkeys; track $index) {
              <mat-chip-row (removed)="removeSearchkey(key)">
                {{ key }}
                <button matChipRemove [attr.aria-label]="'remove ' + key">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
          </form>
        </div>

        <div class="table-addons">
          <ul>
            @if (options.search) {
              <li class="searchContainer">
                <form (keydown)="searchShortcuts($event.code)">
                  <app-prefix-oms (controlchanged)="searchControl = $event" [counter]="false" [label]="'TABLE.SEARCHBAR' | translate" />
                </form>
                <button type="button" (click)="setSearchkeys()" [tooltip]="'TOOLTIP.TABLE.SEARCH'">
                  <mat-icon>search</mat-icon>
                </button>
                <button type="button" (click)="addSearchkeys()" [tooltip]="'TOOLTIP.TABLE.ADD_SEARCH'">
                  <mat-icon>zoom_in</mat-icon>
                </button>
              </li>
            }
            @if (options.filter) {
              <li class="action" [ngClass]="{ filterHighlight: filtersActive }">
                <button type="button" (click)="openFilterDialog()" [tooltip]="'TOOLTIP.TABLE.SHOW_FILTERS'">
                  <mat-icon>{{ "filter_alt" }}</mat-icon>
                </button>
              </li>
            }
            @if (options.filter || options.search) {
              <li class="action">
                <button type="button" [tooltip]="'TOOLTIP.TABLE.CLEAR'" (click)="onClear()">
                  <mat-icon>cancel</mat-icon>
                </button>
              </li>
            }
          </ul>
        </div>
      </div>
    }
  </div>
}

@if (root) {
  @switch (view) {
    @case ("list") {
      <app-table-list-view
        [root]="root"
        [headers]="headers"
        [options]="options"
        (rowSelection)="onRowSelection()"
        (prefixEvent)="onPrefixEvent($event)"
        (sort)="onSort($event)"
        (editEvent)="onEditEvent($event)"
      />
    }
    @case ("tile") {
      <app-table-tile-view
        [root]="root"
        [headers]="headers"
        [options]="options"
        (rowSelection)="onRowSelection()"
        (prefixEvent)="onPrefixEvent($event)"
        (sort)="onSort($event)"
        (editEvent)="onEditEvent($event)"
      />
    }
    @case ("map") {
      <app-table-map-view
        [root]="root"
        [headers]="headers"
        [options]="options"
        (rowSelection)="onRowSelection()"
        (prefixEvent)="onPrefixEvent($event)"
        (sort)="onSort($event)"
        (editEvent)="onEditEvent($event)"
      />
    }
    @default {
      <span>Table view of type '{{ view }}' is not implemented</span>
    }
  }

  @if ((root | tableGroupAmount).visible < 1) {
    <span class="no-rows">{{ "TABLE.NO_ROWS" | translate }}</span>
  }
}

@if (options.foot || buttons.length) {
  <div class="table-footer-container">
    <div class="table-foot">
      <div class="buttonContainer">
        <app-buttons [buttons]="buttons" (event)="onEvent($event)" (deleteSelectedRows)="deleteRows()" [rowsSelected]="selectedRows.length" />
      </div>

      @if (root) {
        @let amount = options.type === "SERVER_SIDE" ? { visible: options.totalRows ?? 0, total: options.totalRows ?? 0 } : (root | tableGroupAmount);
        @let start = options.type === "SERVER_SIDE" ? options.pageSize * (serverSidePage - 1) + 1 : amount.visible === 0 ? 0 : options.pageSize * (page - 1) + 1;
        @let end = start - 1 + options.pageSize > amount.visible ? amount.visible : start - 1 + options.pageSize;
        <div class="paginator">
          <button
            [disabled]="(options.type === 'SERVER_SIDE' ? serverSidePage : page) <= 1"
            (click)="options.type === 'SERVER_SIDE' ? paginateServerSide(serverSidePage - 1) : paginate(page - 1)"
          >
            <mat-icon>chevron_left</mat-icon>
          </button>
          <span>{{ start }} - {{ end }} of {{ amount.visible }}</span>
          <button [disabled]="end === amount.visible" (click)="options.type === 'SERVER_SIDE' ? paginateServerSide(serverSidePage + 1) : paginate(page + 1)">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      }
    </div>
  </div>
}

@if (hiddenForm) {
  <div style="position: absolute; left: 100vw; display: none; width: 0px; height: 0px">
    <!-- <div style="position: absolute; top: 0; left: 0; width: 700px"> -->
    <app-form
      [title]="hiddenForm.title"
      [fields]="hiddenForm['fields']"
      [attachments]="hiddenForm['attachments']"
      (event)="hiddenForm['onEvent']($event)"
      (statechange)="hiddenForm['onStateChange']($event)"
      (openAttachment)="hiddenForm['openAttachments']($event)"
      [options]="hiddenForm['options']"
      [buttons]="hiddenForm['buttons']"
      [mode]="hiddenForm['mode']"
      [credits]="hiddenForm['credits']"
      [collection]="hiddenForm['fieldCollection']"
      [buttonenabled]="hiddenForm['buttonenabled']"
    />
  </div>
}
